module.exports = __webpack_public_path__ + "img/5.626c94a8.jpg";